<template>
    <div></div>
</template>

<script>
    import Axios from 'axios';
    export default {
        name: "TelegramAuth",
        mounted() {
            let telegramUserId = this.$route.query.id;
            let telegramUserPhoto = this.$route.query.photo_url;
            Axios.get(`https://trade-event-ct.herokuapp.com/telegram/inscription?telegramUserId=${telegramUserId}&telegramUserPhoto=${telegramUserPhoto}`).then((response) => {
                if(response.status < 400)
                    alert("Successfully registered on Swiset");
            });
        }
    }
</script>

<style scoped>

</style>
